import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({ name: 'SectionHeader' })((theme) => ({
  container: {
    width: '100%',
  },
  titleText: {
    textTransform: 'uppercase',
    color: theme.palette.text.primary,
  },
}));

export default useStyles;
